import { ColourLabel } from '@cbgms/components/general/ColourLabel'

interface Props {
  content: string
}

export function HexColour({ content }: Props) {
  return <ColourLabel colour={content} />
}
